import { createRoot } from 'react-dom/client';
import { AppRoutes } from './routes';
import './ui/tokens.css';

const root = document.getElementById('root');
if (!root) throw new Error('Application root is missing');
createRoot(root).render(<AppRoutes />);
